export default __webpack_public_path__ + "static/media/Jira-blue.1bc48573.svg";